import { zodResolver } from '@hookform/resolvers/zod';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { EmailSchema } from '../../../utils/schema';
import { SimpleLayout } from '../../layouts/simple-layout';
import { BaseInput } from '@components/molecules';
import type { ResponseResult } from '@utils';
import { WithControl } from '@utils';

export type SelectEmailFormLabels = {
	title: string;
	subtitle: string;
	submit: string;
	noLinkButton: string;
	label: string;
};

type Props = {
	labels: SelectEmailFormLabels;
	onSubmit: (data: { email: string }) => Promise<ResponseResult<any>>;
	goBack?: () => void;
};

const schema = z.object({
	email: EmailSchema,
});

export const ChooseEmailForm: React.FC<Props> = ({ labels, onSubmit, goBack }) => {
	const {
		control,
		handleSubmit,
		formState: { isValid, isSubmitting, errors },
		setError,
	} = useForm({
		defaultValues: {
			email: '',
		},
		resolver: zodResolver(schema),
	});

	const ControlledEmailInput = WithControl(BaseInput, control);

	const handleOnSubmit = async (values: z.infer<typeof schema>) => {
		const { error } = await onSubmit(values);

		if (error) {
			setError('email', { message: error.message });
		}
	};

	return (
		<SimpleLayout
			title={labels.title}
			subtitle={labels.subtitle}
			submitButton={labels.submit}
			linkButton={labels.noLinkButton}
			handleSubmit={handleSubmit(handleOnSubmit)}
			isValid={isValid}
			isLoading={isSubmitting}
			onLinkClick={goBack}
		>
			<div className="flex flex-col gap-2.5">
				<ControlledEmailInput
					name="email"
					type="email"
					label={labels.label}
					error={errors.email?.message}
					data-aid="code-input"
				/>
			</div>
		</SimpleLayout>
	);
};
